import { invitation, invitationDetails } from '@/types/legacyInvitation';

export enum ActionTypes {
  FETCH_INVITATIONS_START = 'invitations/FETCH_INVITATIONS_START',
  FETCH_INVITATIONS_SUCCESS = 'invitations/FETCH_INVITATIONS_SUCCESS',
  FETCH_INVITATIONS_FAIL = 'invitations/FETCH_INVITATIONS_FAIL',
  FETCH_INVITATION_DETAIL_START = 'invitations/FETCH_INVITATION_DETAIL_START',
  FETCH_INVITATION_DETAIL_SUCCESS = 'invitations/FETCH_INVITATION_DETAIL_SUCCESS',
  FETCH_INVITATION_DETAIL_FAIL = 'invitations/FETCH_INVITATION_DETAIL_FAIL',
  CHANGE_PAGE = 'invitations/CHANGE_PAGE',
  SET_SELECTED_INVITATION = 'invitations/SET_SELECTED_INVITATION',
  CLEAR_INVITATIONS = 'invitations/CLEAR_INVITATIONS',
  ADD_SELECTED_INVITATION = 'invitations/ADD_SELECTED_INVITATION',
  UPDATE_FILTERED = 'invitations/UPDATE_FILTERED',
}

export interface State {
  isLoading: boolean;
  error: string;
  items: invitation[];
  page: number;
  totalItems: number;
  details: {
    isLoading: boolean;
    error: string;
    data: invitationDetails[] | [];
  };
  filtered: invitation[];
  selected?: invitation | undefined;
  fetchTime?: number;
}

export interface FetchInvitationsStartAction {
  type: ActionTypes.FETCH_INVITATIONS_START;
}
export interface FetchInvitationsSuccessAction {
  type: ActionTypes.FETCH_INVITATIONS_SUCCESS;
  payload: invitation[];
  totalItems: number;
}
export interface FetchInvitationsFailAction {
  type: ActionTypes.FETCH_INVITATIONS_FAIL;
  payload: string;
}

export interface FetchInvitationDetailStartAction {
  type: ActionTypes.FETCH_INVITATION_DETAIL_START;
}
export interface FetchInvitationDetailSuccessAction {
  type: ActionTypes.FETCH_INVITATION_DETAIL_SUCCESS;
  payload: invitationDetails[];
}
export interface FetchInvitationDetailFailAction {
  type: ActionTypes.FETCH_INVITATION_DETAIL_FAIL;
  payload: string;
}

export interface ChangePage {
  type: ActionTypes.CHANGE_PAGE;
  payload: number;
}

export interface AddSelectedInvitation {
  type: ActionTypes.ADD_SELECTED_INVITATION;
  payload: invitation;
}

export interface SetSelectedInvitation {
  type: ActionTypes.SET_SELECTED_INVITATION;
  payload: invitation;
}

export interface ClearInvitations {
  type: ActionTypes.CLEAR_INVITATIONS;
}

export interface UpdateFilteredAction {
  type: ActionTypes.UPDATE_FILTERED;
  payload: invitation[];
}

export type ActionType =
  | FetchInvitationsStartAction
  | FetchInvitationsSuccessAction
  | FetchInvitationsFailAction
  | FetchInvitationDetailStartAction
  | FetchInvitationDetailSuccessAction
  | FetchInvitationDetailFailAction
  | ChangePage
  | SetSelectedInvitation
  | AddSelectedInvitation
  | ClearInvitations
  | UpdateFilteredAction;
